import isArray from "lodash/isArray";
import size from "lodash/size";

/**
 * @description check param is an array and is not empty
 * @returns
 */
export function isArrayFilled<T>(item: T[]): boolean {
  return isArray(item) && size(item) > 0;
}
